import React from 'react';
import { WebinarLink } from './WebinarLink';
export const Problem = ({
  openModal
}) => {
  // Add the openModal prop and the helper function
  const replaceWebinarWithLink = text => {
    const parts = text.split(/(\bwebinar\b)/i);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'webinar') {
        return <WebinarLink key={index} onClick={openModal} data-id="element-164">
            webinar
          </WebinarLink>;
      }
      return part;
    });
  };
  return <section className="mb-10" data-id="element-165">
      <p className="mb-6 leading-relaxed" data-id="element-166">
        Een groot onderzoek in Engeland laat zien dat straffen heel slecht is
        voor honden. Wetenschappers onderzochten bijna 4.000 honden. Ze
        ontdekten iets schokkends.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-167">
        Honden die gestraft worden, zijn 3 keer vaker agressief naar hun baasje.
        Dit betekent dat ze vaker grommen, blaffen of bijten.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-168">
        De onderzoekers waren Casey en zijn team (Casey et al. (2014).) Hun
        onderzoek kwam uit in 2014. Nu waarschuwen de experts ook in Nederland:
        stop met streng straffen.
      </p>

      <h2 className="text-xl font-bold text-blue-800 mb-4" data-id="element-169">
        De conclusie van het onderzoek is simpel: Straffen maakt honden
        agressiever.
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-170">
        Recent legde Amee het tijdens{' '}
        <a href="https://stresslessdogs.nl/mcc-meta-adv1" className="text-blue-600 cursor-pointer hover:underline" target="_blank" rel="noopener noreferrer" onClick={openModal} data-id="element-171">
          haar online presentatie
        </a>{' '}
        uit, waar honderden mensen bij aanwezig waren. Ze legde uit dat:
      </p>
      <p className="mb-6 leading-relaxed italic" data-id="element-172">
        "Honden die gestraft worden gedragen zich slechter...Ze zijn niet
        rustiger. Ze worden juist agressiever en hun probleemgedrag neemt toe.
        Dit is een groot verschil. Straffen werkt dus niet. Het maakt alles
        erger. Bekijk maar de cijfers uit dit onderzoek"
      </p>
      <p className="mb-6 leading-relaxed font-semibold" data-id="element-173">
        De cijfers uit het onderzoek waren óók schokkend en spreken eigenlijk
        voor zichzelf:
      </p>
      <ul className="mb-6 list-disc pl-5 space-y-2" data-id="element-174">
        <li data-id="element-175">
          Honden die alleen beloond en positief getrained worden: 12 van de 100
          zijn agressief
        </li>
        <li data-id="element-176">Honden die gestraft worden: 36 van de 100 zijn agressief</li>
      </ul>
    </section>;
};